import { render, staticRenderFns } from "./GetDataAnswerList.vue?vue&type=template&id=20b9f308&scoped=true"
import script from "./GetDataAnswerList.vue?vue&type=script&lang=js"
export * from "./GetDataAnswerList.vue?vue&type=script&lang=js"
import style0 from "./GetDataAnswerList.vue?vue&type=style&index=0&id=20b9f308&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b9f308",
  null
  
)

export default component.exports